import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Card, CardContent, Grid} from "@mui/material";
import {blueColor, greyishBlue500} from "../../../../assets/jss/main";
import {FormattedMessage} from "react-intl";
import BoxGrouped from "../../../../assets/img/wms/boxGrouped.svg";
import RadioGroup from "../../../../components/radioGroup/RadioGroup";
import FormControlLabel from "../../../../components/radioGroup/FormControlLabel";
import CustomButton from "../../../../components/CustomButton";
import {getPickingMissionModels} from "../../../../api/wms/missionType/list";
import {WMSContext} from "../../context/WMSContext";
import {createTaskWithModel, getTaskWithModel} from "../../../../api/wms/tasks/list";
import Badge from "../../../../components/Badge";
import {WmsTaskStatus} from "../../../../utils/WMSTaskStatus";

SelfTaskAffectation.propTypes = {
    setRetrievedTask: PropTypes.func.isRequired,
    setOpenNoTaskToast: PropTypes.func.isRequired,
};

function SelfTaskAffectation({setRetrievedTask, setOpenNoTaskToast}) {
    const {currentInventory, currentMember} = useContext(WMSContext)
    const [missionModels, setMissionModels] = useState([])
    const [selectedModel, setSelectedModel] = useState({})

    const handleSelectMissionModel = () => {
        if (undefined !== selectedModel.value) {
            if(selectedModel.auto) {
                getTaskWithModel(selectedModel.value).then((response) => {
                    setRetrievedTask(response);
                })
            } else {
                createTaskWithModel(selectedModel.value, currentMember.id).then((response) => {
                    if (response.status) {
                        setRetrievedTask(response.task)
                    } else {
                        setOpenNoTaskToast(true)
                    }
                })
            }

        }
    }

    const handleFilterNoTaskModel = (models) => {
        return models.filter(
            model =>
                false === model.auto || (
                    model.wmsTasks && model.wmsTasks.some(
                        task =>
                            (!task.member || task.member === null) && task.status === WmsTaskStatus.IDLE
                    ))
        )
    }

    const handleMissionModelLabel = (model) => {
        const isAutoLabel = model.auto ? 'wms.myPickingMissions.noPickingMissions.autoAffectationMission.missionModel.isAuto' : 'wms.myPickingMissions.noPickingMissions.autoAffectationMission.missionModel.isManual'
        let missionCount = 0

        if (model.auto) {
            model.tasks.map((task) => {
                if ((null === task.member || !task.member) && WmsTaskStatus.IDLE === task.status) {
                    missionCount++
                }
            })
        }

        return (
            <Grid container gap={'8px'}>
                {model.label}
                <Badge rounded color={'info'} label={<FormattedMessage id={isAutoLabel}/>}/>
                {model.auto && (
                    <Badge rounded color={'info'} label={<span>{missionCount} <FormattedMessage id={"wms.myPickingMissions.noPickingMissions.autoAffectationMission.missionModel.missionNumberLabel"}/></span>}/>
                )}
                <Badge rounded color={model.itemCount > 0 ? 'oceanBlue' : 'error'} label={<span>{model.itemCount} <FormattedMessage id={"wms.myPickingMissions.noPickingMissions.autoAffectationMission.missionModel.itemCountBadge"}/> </span>}/>
            </Grid>
        )
    }

    useEffect(() => {
        let res = []
        if (currentInventory) {
            getPickingMissionModels(currentInventory).then((response) => {
                res = handleFilterNoTaskModel(response)
                res = res.filter(missionModels => undefined === missionModels.member)
                res = res.map(missionModel => {
                    return {
                        value: missionModel.id,
                        label: missionModel.name,
                        tasks: missionModel.wmsTasks,
                        auto: missionModel.auto,
                        itemCount: missionModel.itemCount
                    }
                })
                setMissionModels(res)
            })
        }
    }, [currentInventory]);

    return (
        <Card sx={{overflow: 'unset'}}>
            <CardContent style={{height: "fit-content", padding: "16px"}}>
                <Grid container>
                    <Grid item style={{color: blueColor}}>
                        <FormattedMessage id={"wms.myPickingMissions.noPickingMissions"}/>
                    </Grid>
                    <Grid container direction={"column"} margin={"32px 0"}>
                        <img src={BoxGrouped} alt={"Box Grouped"}/>
                        <span style={{
                            marginTop: "16px",
                            padding: "0 40px",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: greyishBlue500,
                            textAlign: "center"
                        }}>
                            <FormattedMessage id={"wms.myPickingMissions.noPickingMissions.autoAffectationMission"}/>
                        </span>
                    </Grid>
                    <Grid container direction={"column"}>
                        <Grid item style={{marginBottom: "16px"}}>
                            <RadioGroup
                                alignListWithButton
                                placeholder={<FormattedMessage id={"wms.myPickingMissions.noPickingMissions.missionChoice.placeholder"}/>}
                                value={selectedModel.value}
                                selectedValueLabel={selectedModel.label}
                                onChange={(event) => {
                                    setSelectedModel(missionModels.find(model => model.value === event.target.value))
                                }}
                            >
                                {missionModels.map((missionModel, index) => (
                                    <FormControlLabel
                                        key={index}
                                        value={missionModel.value}
                                        label={handleMissionModelLabel(missionModel)}
                                    />
                                ))}
                            </RadioGroup>
                        </Grid>
                        <Grid>
                            <CustomButton onClick={handleSelectMissionModel} fullWidth>
                                <FormattedMessage id={"wms.myPickingMissions.noPickingMissions.button"}/>
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Grid>


            </CardContent>
        </Card>
    );
}

export default SelfTaskAffectation;